import { TEditedData, TPaymentModel } from 'modules/settings/models';
import API from 'services/api';

export const createContractCooperationTypes = ({
  payload,
}: {
  payload: TPaymentModel | TEditedData;
}) => API.post('/api/cooperation-types', payload);
